export default {
  "--color-default": "rgb(0, 25, 79)",
  "--color-default-inverse": "rgb(255, 255, 255)",
  "--color-primary": "rgb(0, 25, 79)",
  "--color-primary-active": "rgb(0, 23, 75)",
  "--color-primary-inverse": "rgb(255, 255, 255)",
  "--color-secondary": "rgb(249, 190, 60)",
  "--color-secondary-active": "rgb(248, 182, 35)",
  "--color-secondary-inverse": "rgb(0, 25, 79)",
  "--color-tertiary": "rgb(155, 8, 79)",
  "--color-tertiary-active": "rgb(147, 7, 75)",
  "--color-tertiary-inverse": "rgb(255, 255, 255)",
  "--color-sahara-sand": "rgb(252, 246, 160)",
  "--color-flame-pea": "rgb(243, 151, 107)",
  "--color-roman": "rgb(227, 97, 100)",
  "--color-cerise": "rgb(155, 8, 79)",
  "--color-atlantis": "rgb(193, 233, 78)",
  "--color-calypso": "rgb(25, 108, 132)",
  "--color-blue-dianne": "rgb(12, 57, 68)",
  "--color-silver-tree": "rgb(112, 175, 144)",
  "--color-zeus": "rgb(71, 65, 54)",
  "--color-brick-red": "rgb(198, 46, 67)",
  "--color-parsley": "rgb(36, 103, 58)",
  "--color-broom": "rgb(255, 243, 13)",
  "--color-neutral-0": "rgb(20, 24, 31)",
  "--color-neutral-10": "rgb(31, 39, 50)",
  "--color-neutral-20": "rgb(59, 73, 94)",
  "--color-neutral-30": "rgb(79, 97, 125)",
  "--color-neutral-40": "rgb(88, 109, 141)",
  "--color-neutral-50": "rgb(130, 148, 176)",
  "--color-neutral-60": "rgb(161, 175, 196)",
  "--color-neutral-70": "rgb(192, 202, 216)",
  "--color-neutral-80": "rgb(224, 228, 235)",
  "--color-neutral-85": "rgb(236, 239, 243)",
  "--color-neutral-90": "rgb(242, 244, 247)",
  "--color-neutral-95": "rgb(249, 250, 251)",
  "--color-neutral-100": "rgb(255, 255, 255)",
  "--color-success": "rgb(39, 174, 96)",
  "--color-success-active": "rgb(37, 165, 91)",
  "--color-success-inverse": "rgb(255, 255, 255)",
  "--color-danger": "rgb(217, 58, 58)",
  "--color-danger-active": "rgb(214, 46, 46)",
  "--color-danger-inverse": "rgb(255, 255, 255)",
  "--color-warning": "rgb(230, 121, 25)",
  "--color-warning-active": "rgb(220, 116, 24)",
  "--color-warning-inverse": "rgb(255, 255, 255)",
  "--color-yellow": "rgb(245, 196, 0)",
  "--color-yellow-active": "rgb(235, 188, 0)",
  "--color-yellow-inverse": "rgb(255, 255, 255)",
  "--color-text": "rgb(12, 57, 68)",
  "--color-text-light": "rgb(130, 148, 176)",
  "--color-text-lighter": "rgb(161, 175, 196)",
  "--text-color-disabled": "rgb(192, 202, 216)",
  "--text-color-inverse": "rgb(249, 250, 251)",
  "--text-color-link": "rgb(0, 25, 79)",
  "--text-color-link-active": "rgb(0, 23, 75)",
  "--text-color-primary": "rgb(0, 25, 79)",
  "--text-color-primary-inverse": "rgb(255, 255, 255)",
  "--text-color-secondary": "rgb(249, 190, 60)",
  "--text-color-secondary-inverse": "rgb(0, 25, 79)",
  "--text-color-success": "rgb(39, 174, 96)",
  "--text-color-success-inverse": "rgb(255, 255, 255)",
  "--text-color-warning": "rgb(230, 121, 25)",
  "--text-color-warning-inverse": "rgb(255, 255, 255)",
  "--text-color-danger": "rgb(217, 58, 58)",
  "--text-color-danger-inverse": "rgb(255, 255, 255)",
  "--background-color-base": "rgb(255, 255, 255)",
  "--background-color-soft": "rgb(249, 250, 251)",
  "--background-color-softer": "rgb(242, 244, 247)",
  "--background-color-softer-active": "rgb(249, 250, 251)",
  "--background-color-softest": "rgb(236, 239, 243)",
  "--background-color-softest-active": "rgb(242, 244, 247)",
  "--background-color-inverse": "rgb(20, 24, 31)",
  "--background-color-inverse-soft": "rgb(31, 39, 50)",
  "--background-color-inverse-softer": "rgb(59, 73, 94)",
  "--background-color-inverse-softer-active": "rgb(79, 97, 125)",
  "--background-color-disabled": "rgb(242, 244, 247)",
  "--background-color-primary": "rgb(0, 25, 79)",
  "--background-color-primary-active": "rgb(0, 23, 75)",
  "--background-color-primary-inverse": "rgb(255, 255, 255)",
  "--background-color-secondary": "rgb(249, 190, 60)",
  "--background-color-secondary-active": "rgb(248, 182, 35)",
  "--background-color-secondary-inverse": "rgb(0, 25, 79)",
  "--background-color-success": "rgb(39, 174, 96)",
  "--background-color-success-active": "rgb(37, 165, 91)",
  "--background-color-success-inverse": "rgb(255, 255, 255)",
  "--background-color-warning": "rgb(230, 121, 25)",
  "--background-color-warning-active": "rgb(220, 116, 24)",
  "--background-color-warning-inverse": "rgb(255, 255, 255)",
  "--background-color-danger": "rgb(217, 58, 58)",
  "--background-color-danger-active": "rgb(214, 46, 46)",
  "--background-color-danger-inverse": "rgb(255, 255, 255)",
  "--border-color-base": "rgb(224, 228, 235)",
  "--border-color-soft": "rgb(236, 239, 243)",
  "--border-color-softer": "rgb(242, 244, 247)",
  "--border-color-active": "rgb(0, 25, 79)",
  "--border-color-primary": "rgb(0, 25, 79)",
  "--border-color-success": "rgb(39, 174, 96)",
  "--border-color-warning": "rgb(230, 121, 25)",
  "--border-color-danger": "rgb(217, 58, 58)"
}